import { CampaignControllerApiFactory } from '@ce-openapi/campaign-service-api-documentation-ts-axios-client';
import { axios } from '@pukka/auth';
import { constants } from '@pukka/common';
import { queryClient } from '@pukka/tanstack-query';
import { AxiosError } from 'axios';

import { CampaignModel } from '../models';

interface GetCampaignListParams {
  readonly outletId?: number;
  readonly perPage?: number;
  readonly status?: string;
  readonly page?: number;
}

const CAMPAIGN_QUERY_KEY = 'campaigns';

const { MOKA_GOAUTH_SERVICE } = constants;

const CAMPAIGN_API = `${MOKA_GOAUTH_SERVICE}/campaign`;
const CAMPAIGNS_URL = `${MOKA_GOAUTH_SERVICE}/campaign/v1/campaigns`;

const campaignApi = CampaignControllerApiFactory(undefined, CAMPAIGN_API, axios as Parameters<typeof CampaignControllerApiFactory>[2]);

const handleFailedMutation = (error: AxiosError<CampaignModel.CampaignErrorResponse>) => {
  if (!error.response) {
    throw error;
  }

  const {
    data: { message },
  } = error.response;

  if (message) {
    error.message = message;
  }

  throw error;
};

const getCampaignList = async ({ outletId, status, perPage, page }: GetCampaignListParams) =>
  campaignApi.v1CampaignsGet(undefined, undefined, outletId, perPage, status, page, undefined).then((res) => res.data);

const createCampaign = (createCampaignRequest: CampaignModel.CreateRequest) =>
  campaignApi
    .v1CampaignsPost(undefined, undefined, createCampaignRequest)
    .then((resp) => resp.data)
    .catch(handleFailedMutation);

const deleteCampaign = (campaignId: CampaignModel.Detailed['id']) =>
  campaignApi
    .v1CampaignsCampaignIdDelete(campaignId)
    .then((resp) => resp.data)
    .catch(handleFailedMutation);

const editCampaign = ({ campaignId, campaignData }: CampaignModel.EditRequest) =>
  campaignApi
    .v1CampaignsCampaignIdPut(campaignId, undefined, undefined, campaignData)
    .then((resp) => resp.data)
    .catch(handleFailedMutation);

const updateCampaignStatus = ({ campaignId, campaignStatus }: CampaignModel.UpdateStatusRequest) =>
  campaignApi
    .v1CampaignsCampaignIdStatusPatch(campaignId, undefined, undefined, campaignStatus)
    .then((resp) => resp.data)
    .catch(handleFailedMutation);

const invalidateCampaigns = () => queryClient.invalidateQueries([CAMPAIGN_QUERY_KEY]);

export {
  getCampaignList,
  createCampaign,
  deleteCampaign,
  editCampaign,
  updateCampaignStatus,
  invalidateCampaigns,
  handleFailedMutation as _handleFailedMutation,
  CAMPAIGN_QUERY_KEY,
  CAMPAIGNS_URL,
};
